/** @file Wraps a playback frame into [start, end); a range of length 0 or less holds its start. */

/** `start + ((frame - start) mod (end - start))`, always in [start, end); `end <= start` returns `start`. */
export function wrapFrame(frame: number, start: number, end: number): number {
  const span = end - start;
  if (!(span > 0)) return start;
  const r = (frame - start) % span;
  return start + (r < 0 ? r + span : r);
}
